<div class="grid">
  <div class="col-12">
    <div class="mb-3">
      <button pButton
              type="button"
              label="Montrer tout"
              (click)="expandAll()"
              class="mr-2"></button>
      <button pButton
              type="button"
              label="Cacher tout"
              (click)="collapseAll()"></button>
    </div>
    <div class="card">
      <h5>Ressources</h5>
      <p-tree [value]="ressourcesFormatted">
        <ng-template let-node
                     pTemplate="url">
          <a (click)="downloadFile(node.data)">{{ node.label }}</a>
        </ng-template>
        <ng-template let-node
                     pTemplate="label">
          <b>{{node.label}}</b>
        </ng-template>
      </p-tree>
    </div>
  </div>
</div>

<div>

  <ngx-doc-viewer
    [url]="'http://localhost:5007/var/assets/medias/03581781_esp_5_s01_014_acs/index.html'"
    viewer="url"
    style="height:500px;"
  >

  </ngx-doc-viewer>
</div>
